import { FilterFaqChatBotTypeWithPaginationAndSorting } from "@ac-expo/api-types";

const faqChatbotQueryKeys = {
  all: ["faq-chatbot"] as const,
  list: (filters: FilterFaqChatBotTypeWithPaginationAndSorting) =>
    [...faqChatbotQueryKeys.all, "list", filters] as const,
};

export default faqChatbotQueryKeys;
